import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  overrides: {
    secondarySidebar: null,
    conversationMenu: null,
    contactPanel: null,
  },
  source: null,
  userConversationMenu: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
